// Restos do login falso (CA16): usuário com senha e o nome livre de "Quem está juntando?".
export const LEGACY_KEYS = ["user", "antecipe.mergeActorName"];

export const clearLegacyStorage = () => {
  LEGACY_KEYS.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      // storage bloqueado: nada a limpar
    }
  });
};
